import Swiper from "swiper/bundle";
import "swiper/css/bundle";

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".mySwiper").forEach((slider) => {
		new Swiper(slider, {
			spaceBetween: 20,
			//centeredSlides: true,

			pagination: {
				el: slider.querySelector(".swiper-pagination"),
				clickable: true,
			},
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 3,
				},
				999: {
					slidesPerView: 4,
				},
			},
		});
	});
});
